"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var geometry_exports = {};
__export(geometry_exports, {
  boxContains: () => boxContains,
  boxUnion: () => boxUnion,
  boxesOverlap: () => boxesOverlap,
  bpmnMetrics: () => bpmnMetrics,
  labelAscent: () => labelAscent,
  labelBlockHeight: () => labelBlockHeight,
  labelDescent: () => labelDescent,
  labelLineBoxes: () => labelLineBoxes,
  overlapArea: () => overlapArea,
  pointBox: () => pointBox,
  segmentBox: () => segmentBox,
  splitIntoLines: () => splitIntoLines,
  textBlockWidth: () => textBlockWidth,
  textLineBox: () => textLineBox,
  textWidth: () => textWidth
});
module.exports = __toCommonJS(geometry_exports);
const bpmnMetrics = {
  padding: 24,
  titleHeight: 34,
  columnGap: 56,
  rowGap: 28,
  fontSize: 13,
  lineHeight: 16,
  /** Average glyph width for the label font, used to wrap labels without measuring. */
  charWidth: 6.8,
  /**
   * Space kept between the label written inside a shape and the border of that shape, on
   * every side. A shape is never smaller than its kind asks for, and grows past it by
   * whatever the text needs beyond this padding, so no label is ever cut.
   */
  shapeLabelPadding: 8,
  /** Words a flow label puts on one line, so the text stays narrow however long it is. */
  maxFlowLabelWords: 3,
  /**
   * Width a flow label is wrapped to when the room it has is not a column gap: under the
   * elements, where a backward flow is routed, and beside the vertical run of a message
   * flow. Both are wide, the cap is only there to keep a long name from spanning the picture.
   */
  maxFlowLabelWidth: 200,
  labelGap: 6,
  /**
   * Space kept on either side of the label of a flow: between the text and the shape it
   * comes from, and between the text and the elbow the flow drops at. It keeps the label
   * off both, and well before the arrow head, which waits a whole column away.
   */
  flowLabelPadding: 12,
  /** Free space kept between a placed label and whatever it is tested against. */
  labelClearance: 2,
  /** Half the ink of a flow line, a label is kept off the line itself by this much. */
  edgeInk: 1,
  /** Side of the box the arrow head at the end of a flow occupies. */
  arrowSize: 8,
  loopLaneGap: 18,
  selfLoopOffset: 15,
  /** Strip at the left of a pool, respectively of a lane, that holds its vertical label. */
  poolHeaderWidth: 28,
  laneHeaderWidth: 24,
  /** Space kept between the elements of a band and the frame around them. */
  lanePadding: 20,
  minLaneHeight: 88,
  /**
   * Vertical gap between two pool frames. A message flow crosses it, and is named in it
   * whenever it can be, so the gap holds a line of text with the clearance a label keeps.
   */
  poolGap: 28,
  /** Width of the frame of a pool that holds no element at all. */
  minPoolWidth: 240
};
const labelAscent = bpmnMetrics.fontSize;
const labelDescent = bpmnMetrics.fontSize / 3;
function overlap1d(aMin, aMax, bMin, bMax) {
  return Math.min(aMax, bMax) - Math.max(aMin, bMin);
}
__name(overlap1d, "overlap1d");
function boxesOverlap(a, b, clearance = 0) {
  return overlap1d(a.x - clearance, a.x + a.width + clearance, b.x, b.x + b.width) > 0 && overlap1d(a.y - clearance, a.y + a.height + clearance, b.y, b.y + b.height) > 0;
}
__name(boxesOverlap, "boxesOverlap");
function overlapArea(a, b, clearance = 0) {
  const width = overlap1d(a.x - clearance, a.x + a.width + clearance, b.x, b.x + b.width);
  const height = overlap1d(a.y - clearance, a.y + a.height + clearance, b.y, b.y + b.height);
  return width > 0 && height > 0 ? width * height : 0;
}
__name(overlapArea, "overlapArea");
function boxContains(outer, inner) {
  return inner.x >= outer.x && inner.y >= outer.y && inner.x + inner.width <= outer.x + outer.width && inner.y + inner.height <= outer.y + outer.height;
}
__name(boxContains, "boxContains");
function boxUnion(boxes) {
  if (boxes.length === 0) return void 0;
  const left = Math.min(...boxes.map((b) => b.x));
  const top = Math.min(...boxes.map((b) => b.y));
  const right = Math.max(...boxes.map((b) => b.x + b.width));
  const bottom = Math.max(...boxes.map((b) => b.y + b.height));
  return { x: left, y: top, width: right - left, height: bottom - top };
}
__name(boxUnion, "boxUnion");
function segmentBox(from, to, ink = bpmnMetrics.edgeInk) {
  return {
    x: Math.min(from.x, to.x) - ink,
    y: Math.min(from.y, to.y) - ink,
    width: Math.abs(to.x - from.x) + 2 * ink,
    height: Math.abs(to.y - from.y) + 2 * ink
  };
}
__name(segmentBox, "segmentBox");
function pointBox(point, size) {
  return { x: point.x - size / 2, y: point.y - size / 2, width: size, height: size };
}
__name(pointBox, "pointBox");
function splitIntoLines(words, count) {
  const lines = [];
  let index = 0;
  for (let line = 0; line < count; line++) {
    const take = Math.ceil((words.length - index) / (count - line));
    lines.push(words.slice(index, index + take).join(" "));
    index += take;
  }
  return lines;
}
__name(splitIntoLines, "splitIntoLines");
function textWidth(line) {
  return line.length * bpmnMetrics.charWidth;
}
__name(textWidth, "textWidth");
function textBlockWidth(lines) {
  return lines.reduce((max, line) => Math.max(max, textWidth(line)), 0);
}
__name(textBlockWidth, "textBlockWidth");
function textLineBox(line, centerX, baseline) {
  const width = textWidth(line);
  return { x: centerX - width / 2, y: baseline - labelAscent, width, height: labelAscent + labelDescent };
}
__name(textLineBox, "textLineBox");
function labelLineBoxes(lines, position) {
  return lines.filter((line) => line.length > 0).map(
    (line, index, kept) => textLineBox(line, position.x, position.y - (kept.length - 1 - index) * bpmnMetrics.lineHeight)
  );
}
__name(labelLineBoxes, "labelLineBoxes");
function labelBlockHeight(count) {
  return Math.max(0, count - 1) * bpmnMetrics.lineHeight + labelAscent + labelDescent;
}
__name(labelBlockHeight, "labelBlockHeight");
//# sourceMappingURL=geometry.js.map
